/**
 * ScanlineOverlay — CRT scanline effect overlay.
 */

interface ScanlineOverlayProps {
  intensity?: "low" | "medium" | "high";
}

export function ScanlineOverlay({ intensity = "low" }: ScanlineOverlayProps) {
  const opacityMap = {
    low: "opacity-[0.03]",
    medium: "opacity-[0.06]",
    high: "opacity-[0.1]",
  };

  return (
    <div
      className={`
        pointer-events-none
        fixed inset-0 z-50
        ${opacityMap[intensity]}
      `}
      style={{
        background: `repeating-linear-gradient(
          0deg,
          transparent,
          transparent 2px,
          rgba(0, 0, 0, 0.3) 2px,
          rgba(0, 0, 0, 0.3) 4px
        )`,
      }}
    />
  );
}
